// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export interface PostalCodeModalState {
    isOpen: boolean;
}

const initialState: PostalCodeModalState = {
    isOpen: false,
};

const reducer = {
    "PostalCodeModal/CompleteSetIsOpen": (draft: Draft<PostalCodeModalState>, action: PostalCodeModalState) => {
        if (!action.isOpen) {
            return initialState;
        }

        draft.isOpen = action.isOpen;
    },
};

const xPostalCodeModal = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xPostalCodeModal = xPostalCodeModal;

export type xPostalCodeModalState = {
    xPostalCodeModal: PostalCodeModalState;
} & ApplicationState;
